import type { FreightConfig } from "../types/shipment-calculator.type";
import { FormikErrors, FormikTouched } from "formik";
import type { ShipProcessingFee } from "@/schemas/ship";
import { formatNumber } from "@/helpers/pricing/processing-fee-helpers";

interface CalculateForKnownFields {
  mode: string;
  weight: string;
  cbm: string;
}

function CalculateForKnown({
  config,
  touched,
  errors,
  values,
  setFieldValue,
  processingFees,
}: {
  config: FreightConfig;
  touched: FormikTouched<CalculateForKnownFields>;
  errors: FormikErrors<CalculateForKnownFields>;
  values: CalculateForKnownFields;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => Promise<void | FormikErrors<{
    mode: string;
    weight: string;
    cbm: string;
  }>>;
  processingFees: ShipProcessingFee[];
}) {
  const fieldError = touched[config.fieldName] && errors[config.fieldName];
  return (
    <div className="relative">
      <label htmlFor={config.fieldName} className="mb-4 block text-xl font-medium text-[#323232]">
        {config.fieldLabel}
      </label>
      <input
        id={config.fieldName}
        name={config.fieldName}
        type="number"
        min={processingFees?.[0] ? formatNumber(processingFees[0].start_range) : undefined}
        max={
          processingFees?.length
            ? formatNumber(processingFees[processingFees.length - 1].end_range)
            : undefined
        }
        step="0.01"
        value={values[config.fieldName]}
        onChange={(event) => setFieldValue(config.fieldName, event.target.value)}
        placeholder={config.placeholder}
        className="h-[68px] w-full rounded-full border-none bg-white px-6 text-base text-primary-900 shadow-[0px_1.72px_3.45px_0px_rgba(16,24,40,0.05)] outline-none placeholder:text-primary-text-200"
      />
      <p
        className={`absolute -bottom-5 left-0 pl-6 text-xs text-red-500 ${
          fieldError ? "visible" : "invisible"
        }`}
      >
        {fieldError || "No error"}
      </p>
    </div>
  );
}

export default CalculateForKnown;

